export default {"src":"/_next/static/media/icon_dan.91f1ce24.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};